














import Proxyable from '@/mixins/proxyable';
import { IPriceSnapshot } from '@/models';
import { mapActions, mapGetters } from 'vuex';

export default Proxyable.extend({
  name: 'PriceSnapshotPicker',

  props: {
    externalErrorMessage: {
      type: String,
      default: () => ''
    }
  },

  data: () => ({
    loading: false,
    errorMessage: ''
  }),

  computed: {
    ...mapGetters({
      priceSnapshots: 'priceSnapshot/getPriceSnapshots'
    }),

    snapshotList(): IPriceSnapshot[] {
      return this.priceSnapshots;
    },

    errorMessageList(): string[] {
      const errorList = [];
      if (this.externalErrorMessage) {
        errorList.push(this.externalErrorMessage);
      }
      if (this.errorMessage) {
        errorList.push(this.errorMessage);
      }

      return errorList;
    }
  },

  mounted() {
    this.init();
  },

  beforeDestroy() {
    this.errorMessage = '';
  },

  methods: {
    ...mapActions({
      fetchPriceSnapshots: 'priceSnapshot/fetchPriceSnapshots'
    }),

    init() {
      if (!this.snapshotList.length) {
        this.loading = true;
        this.fetchPriceSnapshots({ page: 1 })
          .catch(() => {
            this.errorMessage = 'Error getting snapshots';
          })
          .finally(() => (this.loading = false));
      }
    }
  }
});
